import { render, staticRenderFns } from "./manageWorkgroup.vue?vue&type=template&id=11038020&scoped=true"
import script from "./manageWorkgroup.vue?vue&type=script&lang=js"
export * from "./manageWorkgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11038020",
  null
  
)

export default component.exports